import {
  AspectRatio,
  Card,
  Container,
  SimpleGrid,
  Text,
  Image,
  Title,
  Loader,
  Center,
  Alert,
} from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import Navigation from "@components/Navigation";
import { useBlogPosts } from "@hooks/useBlogPosts";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles((_theme, _, _u) => ({
  card: {
    transition: "transform 150ms ease, box-shadow 150ms ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "var(--mantine-shadow-md)",
    },
  },

  title: {
    fontWeight: "bold",
  },
}));

export default function BlogList() {
  const { classes } = useStyles();
  const { posts, loading, error } = useBlogPosts();
  const navigate = useNavigate();

  if (loading) {
    return (
      <>
        <Navigation />
        <Container py="xl" mt={"72px"}>
          <Center>
            <Loader />
          </Center>
        </Container>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navigation />
        <Container py="xl" mt={"72px"}>
          <Alert color="red" title="Error">
            {error}
          </Alert>
        </Container>
      </>
    );
  }

  const cards = posts.map((post) => (
    <Card
      key={post.id}
      p="md"
      radius="md"
      component="a"
      href={`/blog/${post.slug}`}
      className={classes.card}
      withBorder
      shadow="xl"
      onClick={(event) => {
        event.preventDefault();
        navigate(`/blog/${post.slug}`);
      }}
    >
      {post.featuredImage && (
        <AspectRatio ratio={1920 / 1080}>
          <Image src={post.featuredImage} />
        </AspectRatio>
      )}
      <Text c="dimmed" size="xs" tt="uppercase" fw={700} mt="md">
        {new Date(post.publishedAt).toLocaleDateString()}
      </Text>
      <Text className={classes.title} mt={5}>
        {post.title}
      </Text>
    </Card>
  ));

  return (
    <>
      <Navigation />
      <Container py="xl" mt={"72px"}>
        <Title size={"h2"} mb={"sm"} c="dimmed">
          Blog Posts
        </Title>
        <SimpleGrid cols={{ base: 1, sm: 2 }}>{cards}</SimpleGrid>
      </Container>
    </>
  );
}
